if (!customElements.get("shop-collection")) {
  class ShopCollection extends HTMLElement {
    constructor() {
      super();
      this.container = this;
      this.handleBundleCardVisibilityChange = this.handleBundleCardVisibilityChange.bind(this);
    }

    connectedCallback() {
      this.container.addEventListener(
        "bundle-card-product:visibility-change",
        this.handleBundleCardVisibilityChange
      );
      this.updateVisibility();
    }

    disconnectedCallback() {
      this.container.removeEventListener(
        "bundle-card-product:visibility-change",
        this.handleBundleCardVisibilityChange
      );
    }

    handleBundleCardVisibilityChange() {
      this.updateVisibility();
    }

    updateVisibility() {
      const hasVisibleCards = Array.from(this.container.querySelectorAll(".card-product")).some(
        (card) => !card.classList.contains("card-product-hidden") && !card.classList.contains("bundle-card--hide")
      );
      this.container.classList.toggle("hidden", !hasVisibleCards);
    }
  }
  customElements.define("shop-collection", ShopCollection);
}  
